module.exports = __webpack_public_path__ + "img/australia-logo-icon.26ab44cd.png";